/**
 * useCycleLogs — Completed heat cycles from heat_cycles table
 *
 * Calls the get_completed_cycles RPC which reads pre-materialised
 * cycle data from heat_cycles (populated by materialise_heat_cycles).
 */

import { useState, useEffect, useCallback, useRef } from 'react'
import { supabase } from '@/supabase-client'

export function useCycleLogs() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const mountedRef = useRef(true)

  const fetchLogs = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      // Light materialisation: only scan last 7 days for new/updated cycles
      await supabase.rpc('materialise_heat_cycles', { p_days: 7 })

      // Then read the full history (fast — simple SELECT)
      const { data, error: rpcError } = await supabase.rpc('get_completed_cycles', { p_limit: 50 })

      if (rpcError) throw rpcError
      if (mountedRef.current) setLogs(data || [])
    } catch (err) {
      if (mountedRef.current) {
        console.error('[useCycleLogs] Error:', err)
        setError(err.message)
      }
    } finally {
      if (mountedRef.current) setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchLogs()
  }, [fetchLogs])

  useEffect(() => {
    mountedRef.current = true
    return () => { mountedRef.current = false }
  }, [])

  return { logs, loading, error, refetch: fetchLogs }
}

export default useCycleLogs
